import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ResultsHubAccessService } from './results-hub-access.service';

export const resultsHubDefaultTabGuard: CanActivateFn = () => {
    const accessService = inject(ResultsHubAccessService);
    const router = inject(Router);
    const defaultTab = accessService.defaultTab();

    return router.createUrlTree(defaultTab ? accessService.getResultsHubUrl(defaultTab) : accessService.getModuleHomeUrl());
};

export const resultsHubAnalyticsGuard: CanActivateFn = () => {
    const accessService = inject(ResultsHubAccessService);

    return accessService.canViewAnalytics() || inject(Router).createUrlTree(accessService.getResultsHubUrl());
};

export const resultsHubActionsGuard: CanActivateFn = () => {
    const accessService = inject(ResultsHubAccessService);

    return accessService.canViewActions() || inject(Router).createUrlTree(accessService.getResultsHubUrl());
};
